'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ADMIN: 'ADMIN',
  ANALYST: 'ANALYST',
  CRYPTO_ACCOUNT_CONTROLLER: 'CRYPTO_ACCOUNT_CONTROLLER',
  FIAT_ACCOUNT_CONTROLLER: 'FIAT_ACCOUNT_CONTROLLER',
  PORTFOLIO_AUDITOR: 'PORTFOLIO_AUDITOR',
  PORTFOLIO_MANAGER: 'PORTFOLIO_MANAGER',
  SETTLEMENT_OFFICER: 'SETTLEMENT_OFFICER',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  SYSTEM_INTEGRATOR: 'SYSTEM_INTEGRATOR',
  SYSTEM_OPERATOR: 'SYSTEM_OPERATOR',
  TRADER: 'TRADER'
};